import React from 'react';
import AboutPreview from'../components/About/AboutPreview';
import About from '../components/About/About';

const AboutPage = () => {
  return (
    <div className="pt-20">
      <About />
      <AboutPreview />
    </div>
  );
};

export default AboutPage;